import React, {useEffect, useState} from 'react'

import {useDispatch, useSelector} from "react-redux";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import GlbReceitasView from "./GlbReceitasView";
import {getGlbReceitaCategorias, getGlbPneuModelos, getGlbPneuMedidas, getGlbBandas} from "../../../actions/raspaRecipeActions";
import axios from "../../../axiosApi";

const FULL_ACCESS_USER = 'lukatec.compacta';

const GlbReceitas = ( props ) => {
    const dispatch = useDispatch();
    const username = useSelector(state => state.auth.username);
    const [accessState, setAccessState] = useState('loading'); // loading | full | restricted | denied
    const [categoriasPermitidas, setCategoriasPermitidas] = useState(null); // null = todas, array = filtradas

    useEffect(() => {
        const checkAccess = async () => {
            // 1) Usuario com acesso total
            if (username === FULL_ACCESS_USER) {
                setAccessState('full');
                setCategoriasPermitidas(null);
                return;
            }

            // 2) Buscar parametros com chave contendo "receita.categoria"
            try {
                const filter = JSON.stringify({ where: { chave: { like: '%receita.categoria%' } } });
                const response = await axios.get(`/parametros?filter=${encodeURIComponent(filter)}`);
                const params = response.data;

                if (params && params.length > 0) {
                    const ids = params
                        .map(p => p.valor0Int)
                        .filter(v => v !== null && v !== undefined);

                    if (ids.length > 0) {
                        setCategoriasPermitidas(ids);
                        setAccessState('restricted');
                        return;
                    }
                }
            } catch (e) {
                console.error('Error fetching parametros for access check:', e);
            }

            // 3) Nenhuma condicao atendida
            setAccessState('denied');
        };

        checkAccess();
    }, [username]);

    // Carregar dados globais apenas quando tem acesso
    useEffect(() => {
        if (accessState === 'full' || accessState === 'restricted') {
            dispatch(getGlbReceitaCategorias());
            dispatch(getGlbPneuModelos());
            dispatch(getGlbPneuMedidas());
            dispatch(getGlbBandas());
        }
    }, [accessState]);

    if (accessState === 'loading') {
        return <CircularProgress style={{ margin: 40 }} />;
    }

    if (accessState === 'denied') {
        return (
            <Typography variant="h6" style={{ padding: 40, color: '#999' }}>
                Sem acesso.
            </Typography>
        );
    }

    return (
        <React.Fragment>
            <GlbReceitasView categoriasPermitidas={categoriasPermitidas} />
        </React.Fragment>
    )
}

export default (GlbReceitas);

